import React, { Component } from "react";
import "../../Pages/Login/Login.css";
import Loading from "../../Pages/Signup/Loading";
import ReactPhoneInput from "react-phone-input-2";

const $ = window.$;
export class AddStaffModal extends Component {
  constructor() {
    super();
    this.state = {
      invitingStaff: false,
      phoneNumber: "",
    };
    this.inviteStaff = this.inviteStaff.bind(this);
    this.handlePhoneInput = this.handlePhoneInput.bind(this);
  }

  componentDidMount() {
    if (this.props.isOpen) {
      $("#hc-profile-setting-org-add-modal").modal({
        keyboard: false,
      });
      $("#hc-profile-setting-org-add-modal").modal("show");
    } else {
      $("#hc-profile-setting-org-add-modal").modal("hide");
    }
    $("#hc-profile-setting-org-add-modal").on(
      "hidden.bs.modal",
      function(e) {
        this.props.modalClose();
      }.bind(this),
    );
  }

  inviteStaff(e) {
    e.preventDefault();
    this.setState({ invitingStaff: true });
    this.props.handleInviteStaff(this.state.phoneNumber);
  }

  handlePhoneInput(value) {
    this.setState({
      phoneNumber: value,
    });
  }

  render() {
    return (
      <div className="org-add-staff-modal">
        <div className="org-add-staff-container">
          <div style={{ paddingBottom: "0px" }}>
            <h5 className="hc-primary-text" style={{ fontSize: "1.25rem" }}>
              Add Member
            </h5>
            <div
              className="Form-Container"
              style={{ marginTop: "20px", maxWidth: "100%" }}
            >
              <div
                id="hc-profile-setting-org-add-modal"
                className="form-group"
                style={{ paddingBottom: "1rem" }}
              >
                <div className="card" style={{ paddingLeft: "0px" }}>
                  <ReactPhoneInput
                    placeholder="Registered phone number"
                    country={"ph"}
                    defaultCountry={"ph"}
                    enableLongNumbers={true}
                    onChange={this.handlePhoneInput}
                    value={this.state.phoneNumber}
                    inputStyle={{
                      width: "100%",
                      outline: "none",
                      boxShadow: "none",
                    }}
                    required
                  />
                </div>
              </div>
              {!this.state.invitingStaff ? (
                <div className="form-group" style={{ textAlign: "right" }}>
                  <button
                    style={{ marginRight: "10px" }}
                    className="btn btn-hubchart btn-hubchart-primary"
                    onClick={(e) => this.inviteStaff(e)}
                  >
                    Invite
                  </button>
                  <button
                    type="button"
                    className="btn btn-hubchart btn-hubchart-close"
                    data-dismiss="modal"
                    onClick={() => this.props.modalClose()}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <div
                  className="form-group"
                  style={{
                    textAlign: "right",
                    position: "relative",
                    height: "40px",
                  }}
                >
                  <Loading />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddStaffModal;
